<template>
  <div
    class="muiltple-choice-content"
    :class="{'has-image-choice': $store.state.slide.type == 'imageChoice'}"
  >
    <form @submit="submit">
      <div
        class="slide-img-wrapper"
        v-if="$store.state.slide.image && $store.state.slide.type != 'pickAnswer'"
      >
        <Loading v-if="isLoading" />
        <img
          :src="$store.state.slide.image.large"
          alt
          class="slide-img"
          ref="slide-imgg"
          @load="_imgLoaded"
          v-else
        >
      </div>
      <div
        class="sub-header"
        v-if="$store.state.slide.type == 'imageChoice' && $store.state.slide.SlideOptions.length"
      >
        {{ $t("clickToSeeFullSize") }}
      </div>

      <div v-if="!showQuizTypeAnswer">
        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && $store.state.slide.type != 'pickAnswer'"
        >
          {{ $t("multipleChoiceInstruction") }} {{ $store.state.slide.limitChoice }} {{ $t("options") }}.
        </div>

        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && !this.$store.state.slide.isCorrectGetPoint && $store.state.slide.type == 'pickAnswer'"
        >
          {{ $t("quizYouMustPickAll") }}
        </div>
        <div
          class="sub-header"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.SlideOptions.length > 1 && this.$store.state.slide.isCorrectGetPoint && $store.state.slide.type == 'pickAnswer'"
        >
          {{ $t("mustNotPickIncorrectAnswer") }}
        </div>

        <div
          class="sub-header"
          v-if="!$store.state.slide.multipleChoice && $store.state.slide.type == 'pickAnswer' && checkAnyCorrectAnswer() > 1"
        >
          {{ $t("youCanPickAnyCorrectAnswer") }}
        </div>

        <div
          class="progress-bar-time-limit"
          :class="{'mb-0': !$store.state.presentation.presenting || $store.state.presentation.presenting && !$store.state.slide.hasTimeLimit }"
          v-if="hasTimeLimitOption"
        >
          <ProgressBarTimer />
        </div>

        <div
          class="list-option"
          v-if="!$store.state.slide.multipleChoice && $store.state.slide.slideType != 'imageChoice'"
        >
          <div
            class="input-wrapper"
            :class="{active: item.id == radioSelectded}"
            v-for="(item, index) in $store.state.slide.SlideOptions"
            :key="index"
            v-show="isVisibleOption(index)"
          >
            <input
              class="fancy-radio"
              hidden
              :id="'radio-' + item.id"
              name="radio-group"
              type="radio"
              v-model="radioSelectded"
              @change="handleRadioSelect"
              :value="item.id"
            >

            <div class="horizontal layout box-select">
              <div
                class="image-choice-box horizontal layout center center-justified"
                v-if="item.imageCropped && $store.state.slide.type == 'imageChoice'"
                @click.stop="openImage(item.imageCropped)"
              >
                <div
                  class="bg-color-image-choice"
                  :style="{ 'background-color': $store.state.slide.textColour, 'opacity': 0.1}"
                />
                <img :src="item.imageCropped" alt>
              </div>
              <label class="fancy-radio-label" :for="'radio-' + item.id">
                <div class="checkbox-item-wrapper">
                  <div class="checkbox-item" />
                </div>
                <span class="fancy-label--text">{{ item.title }}</span>
              </label>
            </div>
          </div>
        </div>

        <div
          class="list-option has-multiple"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.slideType != 'imageChoice'"
        >
          <div
            class="input-wrapper"
            :class="{selected: item.selected, disabled: item.disable}"
            v-for="(item, index) in $store.state.slide.SlideOptions"
            :key="index"
            @click="selectOption(item)"
            v-show="isVisibleOption(index)"
          >
            <div class="horizontal layout box-select">
              <div
                class="image-choice-box horizontal layout center center-justified"
                v-if="item.imageCropped && $store.state.slide.type == 'imageChoice'"
                @click.stop="openImage(item.imageCropped)"
              >
                <div
                  class="bg-color-image-choice"
                  :style="{ 'background-color': $store.state.slide.textColour, 'opacity': 0.1}"
                />
                <img :src="item.imageCropped" alt>
              </div>
              <div class="fancy-radio-label">
                <div class="checkbox-item-wrapper">
                  <div class="square-checkbox-item" />
                  <i class="fa fa-check fa-stack-1x" />
                </div>
                <div class="fancy-label--text">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="pick-image-options horizontal layout"
          v-if="$store.state.slide.type == 'pickAnswer' && $store.state.slide.slideType == 'imageChoice'"
          :class="{'has-many-option': $store.state.slide.multipleChoice, 'has-2-option': $store.state.slide.SlideOptions.length == 2}"
        >
          <div class="flex masonry left">
            <div
              class="brick"
              :class="{active: item.selected}"
              v-for="(item, index) in $store.state.slide.SlideOptions"
              :key="index"
              @click="selectOption(item)"
              v-show="(index + 1) % 2 != 0 && isVisibleOption(index)"
            >
              <div class="box-image-choice-option-quiz" :style="{'background-color': boxImgChoiceBg}">
                <div class="option-img-wrapper" v-if="item.imageCropped">
                  <img :src="item.imageCropped">
                  <div class="img-circle">
                    <i class="fas fa-check" />
                  </div>
                </div>
                <div class="option-title" v-if="item.title">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="flex masonry right">
            <div
              class="brick"
              :class="{active: item.selected}"
              v-for="(item, index) in $store.state.slide.SlideOptions"
              :key="index"
              @click="selectOption(item)"
              v-show="(index + 1) % 2 == 0 && isVisibleOption(index)"
            >
              <div class="box-image-choice-option-quiz" :style="{'background-color': boxImgChoiceBg}">
                <div class="option-img-wrapper" v-if="item.imageCropped">
                  <img :src="item.imageCropped">
                  <div class="img-circle">
                    <i class="fas fa-check" />
                  </div>
                </div>
                <div class="option-title" v-if="item.title">
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <!-- .masonry -->
        </div>

        <div
          class="count-choice"
          v-if="$store.state.slide.multipleChoice && $store.state.slide.limitChoice != $store.state.slide.SlideOptions.length && getVoteLeft() && $store.state.slide.SlideOptions.length > 2"
        >
          {{ getVoteLeft() }} {{ $t("choicesLeft") }}
        </div>
      </div>

      <div v-if="showQuizTypeAnswer">
        <div class="text-area" :class="{error: typeAnswerValue.length > limitText}">
          <input
            :placeholder="$t('typeYourAnswer')"
            v-model="typeAnswerValue"
            :maxlength="limitText"
            id="type-answer-value"
            class="item-input-text"
          >
          <div class="count-text">
            {{ limitText - typeAnswerValue.length }}
          </div>
        </div>
      </div>

      <div
        class="btn-submit"
        id="btn-submit"
        v-if="($store.state.slide.SlideOptions && $store.state.slide.SlideOptions.length) || ($store.state.slide.type == 'pickAnswer' && $store.state.slide.slideType == 'typeAnswer')"
        :class="{'dark': $store.state.slide.textColour == '#ffffff'}"
      >
        <ui-button
          block
          size="lg"
          type="submit"
          :disabled="
            submiting
              || $store.state.slide.stopSubmission
          "
        >
          <template v-if="!$store.state.slide.stopSubmission">
            <span>{{ $t("submit") }}</span>

            <CountDownTimer v-if="hasTimeLimitOption" />

            <i class="fas fa-check" v-if="!submiting" />
            <ui-spinner v-else />
          </template>

          <template v-if="this.$store.state.slide.stopSubmission">
            <span>{{ $t("submissionClosedButton") }}</span>
            <i class="fa fa-lock" />
          </template>
        </ui-button>
      </div>

      <div class="pt-0 text-center text-danger padding" v-if="error">
        {{ error }}
      </div>
      <div
        class="stop-submission"
        v-if="this.$store.state.slide.stopSubmission"
      >
        {{ $t("stopSubmission") }}
      </div>
    </form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import Config from '@/config'
import Util from '@/util'
import EvenBus from '@/eventBus'
import Loading from '@/components/Loading'
import PhotoSwipe from 'photoswipe'
import PhotoSwipeUIDefault from 'photoswipe/dist/photoswipe-ui-default'
import storage from '@/services/storage'
import CountDownTimer from '@/components/CountDownTimer'
import ProgressBarTimer from '@/components/ProgressBarTimer'

// UI
import UiButton from '@/components/UI/Button'
import UiSpinner from '@/components/UI/Spinner'

export default {
  components: {
    Loading,
    UiButton,
    UiSpinner,
    CountDownTimer,
    ProgressBarTimer,
  },
  data() {
    return {
      submiting: false,
      error: '',
      count: 0,
      radioSelectded: 0,
      isLoading: false,
      showQuizTypeAnswer: false,
      limitText: 150, // limit input type answer submit
      typeAnswerValue: '',
      boxImgChoiceBg: '',
    }
  },
  computed: {
    ...mapState({
      audienceId: (state) => state.audienceId,
      presentation: (state) => state.presentation,
    }),
    hasTimeLimitOption() {
      return this.$store.state.slide.type === 'imageChoice' ||
       this.$store.state.slide.type === 'multipleChoice' ||
       this.$store.state.slide.type === 'openEnded' ||
       this.$store.state.slide.type === 'wordCloud'
    },
  },
  watch: {
    '$store.state.slide': function () {
      setTimeout(() => {
        if (this.$refs['slide-imgg'] && !this.$refs['slide-imgg'].complete) {
          this.isLoading = true
        }
      }, 1)
    },
  },
  mounted() {
    this.radioSelectded = this.$store.state.slide.radioSelectded
    if (this.$store.state.slide.type === 'pickAnswer') {
      if (this.$store.state.slide.slideType === 'typeAnswer') {
        this.showQuizTypeAnswer = true

        setTimeout(() => {
          if (window.document.getElementById('type-answer-value')) {
            window.document.getElementById('type-answer-value').focus()
          }
        }, 100)
      } else if (this.$store.state.slide.slideType === 'imageChoice') {
        if (this.$store.state.slide.baseColour) {
          this.boxImgChoiceBg = Util.changeRgbAlpha(Util.hexToRgba(this.$store.state.slide.baseColour), 0.5)
        }
      }
      this.$store.state.slide.limitChoice = this.$store.state.slide.SlideOptions.length
      this._setFloatingSubmitBtn()
    }
  },

  destroyed() {
    if (window.onscroll) {
      window.onscroll = null
    }
  },
  methods: {
    isVisibleOption(index) {
      const { type } = this.$store.state.slide
      return (type === 'multipleChoice' && index < 30) ||
       ((type === 'imageChoice' || type === 'pickAnswer' || type === 'scale') && index < 8) ||
       ((type === 'bulletPoints') && index < 15)
    },
    _setFloatingSubmitBtn() {
      const submitBtn = document.getElementById('btn-submit')
      setTimeout(() => {
        const page = document.documentElement
        if (page.scrollHeight > page.clientHeight) {
          if (submitBtn) {
            submitBtn.classList.add('sticky-btn')
          }
        }
      }, 200)

      window.onscroll = () => {
        const docBody = document.documentElement || document.body.parentNode || document.body
        const hasOffset = window.pageYOffset !== undefined
        const scrollTop = hasOffset ? window.pageYOffset : docBody.scrollTop

        if (!submitBtn) return

        if (scrollTop >= docBody.scrollHeight - docBody.clientHeight) {
          submitBtn.classList.remove('sticky-btn')
        } else {
          submitBtn.classList.add('sticky-btn')
        }
      }
    },
    checkAnyCorrectAnswer() {
      let count = 0
      if (!this.$store.state.slide.SlideOptions) return count
      this.$store.state.slide.SlideOptions.forEach((item) => {
        if (item.correct) {
          count++
        }
      })
      return count
    },
    openImage(img) {
      const pswpElement = document.querySelectorAll('.pswp')[0]

      // build items array
      const items = []
      items.push({
        src: img,
        w: -1,
        h: -1,
        title: '',
      })
      // define options (if needed)
      const options = {
        // optionName: 'option value'
        // for example:
        history: false, // disable photoswipe from modifying history, avoid conflict with back to last slide
        index: 0, // start at first slide
      }

      // Initializes and opens PhotoSwipe
      const gallery = new PhotoSwipe(
        pswpElement,
        PhotoSwipeUIDefault,
        items,
        options,
      )

      // $(".pswp__item").addClass("img-none");

      gallery.listen('imageLoadComplete', (index, item) => {
        if (item.w < 1 || item.h < 1) {
          const img = new Image()
          img.src = item.src
          img.onload = function () {
            item.w = img.width
            item.h = img.height
            gallery.invalidateCurrItems()
            gallery.updateSize(true)
          }
          // setTimeout(() => {
          //   $(".pswp__item").removeClass("img-none");

          // }, 500)
        }
      })

      gallery.listen('close', () => {
        // $(gallery.container).removeClass('pswp--ready');
      })

      gallery.init()
    },

    handleRadioSelect() {
      this.$store.dispatch('updateSlide', this.$store.state.slide)
    },

    getVoteLeft() {
      let count = 0
      this.$store.state.slide.SlideOptions.forEach((item) => {
        if (item.selected) {
          count++
        }
      })
      return this.$store.state.slide.limitChoice - count
    },

    selectOption(item) {
      if (!this.$store.state.slide.multipleChoice) {
        this.$store.state.slide.SlideOptions.forEach((item) => {
          item.selected = false
        })
        const index = this.$store.state.slide.SlideOptions.findIndex((option) => {
          return option.id == item.id
        })
        this.$store.state.slide.SlideOptions[index].selected = true
        this.$store.state.slide.SlideOptions.push()
        this.radioSelectded = item.id
        return
      }
      const _checkItem = () => {
        this.count = 0
        this.$store.state.slide.SlideOptions.forEach((item) => {
          item.disable = false
          if (item.selected) {
            this.count++
          }
        })
        if (this.count == this.$store.state.slide.limitChoice) {
          this.$store.state.slide.SlideOptions.forEach((item) => {
            if (!item.selected) {
              item.disable = true
            } else {
              item.disable = false
            }
          })
          this.$store.state.slide.SlideOptions.push()
          return false
        }
        return true
      }

      if (item.selected) {
        item.selected = false
        this.$store.state.slide.SlideOptions.push()
        _checkItem()
      } else if (_checkItem()) {
        item.selected = true
        this.$store.state.slide.SlideOptions.push()
        _checkItem()
      }
    },

    async submit(e) {
      e.preventDefault()
      const self = this

      storage.updateValueByPresentation(this.presentation.id, 'audienceId', this.audienceId)
      const openDialog = () => {
        this.$dialog
          .confirm(
            {
              title: self.$t('notAnswerYet'),
              body: self.$t('continueAnyway'),
            },
            {
              okText: self.$t('okButton'),
              cancelText: self.$t('cancelButton'),
            },
          )
          .then(() => {
            if (self.$store.state.presentation.audiencePacing) {
              EvenBus.$emit('skipSlide')
              return
            }
            self.$store.state.slide.radioSelectded = 1
            self.$store.state.slide.answer = {}
            self.$store.dispatch('updateSlide', self.$store.state.slide)
            EvenBus.$emit('multiple-choice-voted', true)
          })
          .catch(() => {})
      }
      const vote = []

      if (this.$store.state.slide.type == 'pickAnswer') {
        if (this.$store.state.slide.slideType != 'typeAnswer') {
          if (!this.$store.state.slide.multipleChoice && !this.radioSelectded) {
            this.error = this.$t('notAnswerYet')
            return
          } if (this.$store.state.slide.multipleChoice) {
            this.$store.state.slide.SlideOptions.forEach((item) => {
              if (item.selected) {
                vote.push(item.id)
              }
            })
            if (!vote.length) {
              this.error = this.$t('notAnswerYet')
              return
            }
          }
        } else {
          if (!this.typeAnswerValue) {
            return
          }
          const typeAnswerTrim = this.typeAnswerValue.trim()
          if (!typeAnswerTrim) {
            return
          }
        }
      } else {
        if (!this.$store.state.slide.multipleChoice && !this.radioSelectded) {
          openDialog()
          return
        } if (this.$store.state.slide.multipleChoice) {
          this.$store.state.slide.SlideOptions.forEach((item) => {
            if (item.selected) {
              vote.push(item.id)
            }
          })
          if (!vote.length) {
            openDialog()
            return
          }
        }
      }

      this.error = ''
      const payload = {
        presentation: this.$store.state.presentation.id,
        slide: this.$store.state.slide.id,
        audience: this.audienceId,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        slideTimestamp: this.$store.state.slide.slideTimestamp,
        config: {
          timeToAnswer: this.$store.state.slide.timeToAnswer,
          quizTimestamp: this.$store.state.slide.quizTimestamp,
          multipleChoice: this.$store.state.slide.multipleChoice,
          isCorrectGetPoint: this.$store.state.slide.isCorrectGetPoint,
          stopSubmission: this.$store.state.slide.stopSubmission,
          fastAnswerGetMorePoint: this.$store.state.slide
            .fastAnswerGetMorePoint,
          otherCorrectQuiz: this.$store.state.slide.otherCorrectQuiz,
          correctQuizTypeAnswer: this.$store.state.slide.correctQuizTypeAnswer,
          maxPoint: this.$store.state.slide.maxPoint,
          minPoint: this.$store.state.slide.minPoint,
        },
        type: this.$store.state.slide.type,
        slideType: this.$store.state.slide.slideType,
      }

      if (
        this.$store.state.slide.type == 'pickAnswer' &&
        this.$store.state.slide.slideType == 'typeAnswer'
      ) {
        payload.config.SlideOptions = []
        payload.typeAnswer = this.typeAnswerValue
        payload.vote = []
      } else {
        const optionList = []
        this.$store.state.slide.SlideOptions.forEach((dataOption) => {
          optionList.push({
            id: dataOption.id,
            correct: dataOption.correct,
          })
        })
        payload.config.SlideOptions = optionList
        if (!this.$store.state.slide.multipleChoice) {
          payload.vote = [this.radioSelectded]
        } else {
          payload.vote = vote
        }
      }

      if (this.$store.state.slide.type == 'pickAnswer') {
        payload.audienceName = this.$store.state.audienceName
        payload.audienceEmoji = this.$store.state.audienceEmoji
        EvenBus.$emit('quiz-stop-submit')

        if (this.$store.state.presentation.teamPlay) {
          payload.audienceTeam = this.$store.state.audienceQuizTeam
        }
      }
      this.submiting = true
      this.$http.post(Config.api.createAnswer, payload).then(
        (res) => {
          if (this.$store.state.slide.type == 'pickAnswer') {
            res.body.timeAnswer = parseFloat(res.body.timeAnswer)
            let timeLeft =
              this.$store.state.slide.timeToAnswer - res.body.timeAnswer
            timeLeft = parseFloat(timeLeft).toFixed(2)
            EvenBus.$emit('quiz-waiting-result', {
              timeAnswer: res.body.timeAnswer,
              timeLeft,
              answer: res.body,
              notSubmit: true,
            })

            const presentationId = this.$store.state.presentation.id
            const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
            answeredSlideIds.push(this.$store.state.slide.id)
            storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)

            Util.gaTrackEvent(
              'Audience > Quiz',
              'Submit answer',
              'Audience Submit Answer',
            )
          } else {
            this.submiting = false

            const presentationId = this.$store.state.presentation.id
            const answeredSlideIds = storage.getValueByPresentation(presentationId, 'answeredSlideIds', [])
            if (!answeredSlideIds.includes(this.$store.state.slide.id)) {
              answeredSlideIds.push(this.$store.state.slide.id)
              storage.setValueByPresentation(presentationId, 'answeredSlideIds', answeredSlideIds)
            }
            if (
              this.$store.state.slide.type == 'multipleChoice' ||
              this.$store.state.slide.type == 'imageChoice'
            ) {
              EvenBus.$emit('multiple-choice-voted')
            }

            if (this.$store.state.presentation.audiencePacing) {
              EvenBus.$emit('skipSlide')
            } else {
              EvenBus.$emit('confirmNextSlide')
            }

            if (this.$store.state.slide.type === 'multipleChoice') {
              Util.gaTrackEvent(
                'Audience > Multiple Choice',
                'Submit answer',
                'Audience Submit Answer',
              )
            } else if (this.$store.state.slide.type === 'imageChoice') {
              Util.gaTrackEvent(
                'Audience > Image Choice',
                'Submit answer',
                'Audience Submit Answer',
              )
            }
          }
        },
        (err) => {
          this.submiting = false
          if (err.body && err.errorCode === 411) {
            this.error = this.$t('submissionClosedButton')
          } else {
            this.error = this.$t('openendedSubmissionFail')
          }
          Util.gaTrackEvent(
            'Multiple Choice Submit',
            'Audience submit fail',
            JSON.stringify(err),
          )
        },
      )
    },

    _imgLoaded() {
      this.isLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.text-area {
  position: relative;
  padding: 0 16px;
  margin-bottom: 16px;

  textarea {
    width: 100%;
    padding: 10px;
    border-radius: 8px;
    border: 2px solid #ddd;
    -webkit-appearance: none;
    outline: none;
    padding: 10px 20px 10px 10px;
    margin-bottom: 16px;

    &:focus {
      border-color: $primary-color;
    }
  }

  .count-text {
    position: absolute;
    color: #313131;
    bottom: 18px;
    right: 25px;
    font-size: 12px;
  }

  &.error {
    textarea {
      border: 1px solid red;
      &:focus {
        border-color: red;
      }
    }

    .count-text {
      color: red;
    }
  }
}

.option-default-image {
  position: relative;
  .relative,
  .bg-image-column {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    left: 0;
  }
}
.btn-submit {
  margin-bottom: 16px;
  transition: 0.1s ease-in-out;
  &.sticky-btn {
    position: sticky;
    bottom: 25px;
    max-width: 100%;
    .button-submit {
      box-shadow: 0 0 15px 5px rgba(0, 0, 0, 0.2);
    }
    &.dark {
      .button-submit {
        box-shadow: 0 0 15px 5px rgba(208, 208, 208, 0.2);
      }
    }
  }
}
.box-select {
  width: 100%;
}
.has-image-choice {
  .input-wrapper {
    overflow: hidden;
  }
}
.image-choice-box {
  position: relative;
  width: 120px;
  margin-bottom: -1px;
  margin-top: -1px;

  .bg-color-image-choice {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  img {
    position: relative;
    max-width: 100%;
  }
}
.count-choice {
  text-align: center;
  padding: 0 16px;
  padding-bottom: 16px;
  opacity: 0.7;
}
.list-option {
  padding: 0 16px;
  text-align: left;
  margin-top: 16px;
  .fancy-radio-label {
    cursor: pointer;
    min-height: 54px;
    word-break: break-word;
    // white-space: pre-wrap;
    -o-word-wrap: normal;
    -ms-word-wrap: normal;
    word-wrap: normal;
  }
}

.has-multiple {
  .input-wrapper {
    position: relative;
    margin-bottom: 16px;
    border: 2px solid #ddd;
    border-radius: 8px;
    min-height: 30px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    // padding: 16px;
    // padding-left: 60px;
    // line-height: 22px;

    .fa-check {
      display: none;
      font-size: 1.3em;
    }
    .checkbox-item-wrapper {
      position: relative;
    }
    .square-checkbox-item {
      height: 24px;
      width: 24px;
      background: #fff;
      -webkit-box-shadow: 0 0 0 2px #fff, 0px 0px 0 4px #b1b1b1;
      box-shadow: 0 0 0 2px #fff, 0px 0px 0 4px #b1b1b1;
      border-radius: 15%;
    }
    &.selected {
      border-color: $primary-color;
      transition: all 0.2s ease-in-out;
      .checkbox-item-wrapper {
        border-color: $primary-color;
        .square-checkbox-item {
          box-shadow: 0 0 0 2px #fff, 0px 0px 0 4px $primary-color;
          -webkit-box-shadow: 0 0 0 2px #fff, 0px 0px 0 4px $primary-color;
        }
        .fa-check {
          position: absolute;
          display: block;
          width: 100%;
          color: $primary-color;
          top: 1px;
          left: -7px;
        }
      }
    }

    &.disabled {
      color: #b5b5b5;
      border-color: #b5b5b5;

      i {
        color: #b5b5b5;
      }
    }
  }
}

.sub-header {
  text-align: center;
  padding: 0 16px 0 16px;
  opacity: 0.7;
}
.fancy-label--text {
  word-wrap: break-word;
}

.slide-img-wrapper {
  width: auto;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 0.83em;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 15px;

  .slide-img {
    margin-bottom: 16px;
  }

  & /deep/ {
    .spinner {
      width: 120px;
      margin: 0 auto;
    }
    .spinner > div {
      width: 20px;
      height: 20px;
      margin: 0 8px;
    }
  }
}

/* Masonry grid */
.masonry {
  transition: all 0.5s ease-in-out;
  padding: 0 16px;

  &.left {
    padding-right: 8px;
  }
  &.right {
    padding-left: 8px;
  }
}

/* Masonry item */
.masonry .brick {
  margin-bottom: 16px;
  display: block; /* Fix the misalignment of items */
  overflow: hidden;
  cursor: pointer;
  width: 100%;

  .option-title {
    font-size: 16px;
    padding: 10px 8px;
  }
  .box-image-choice-option-quiz {
    border: 2px solid #ddd;
    border-radius: 5px;
    overflow: hidden;
    min-height: 24px;
    .option-img-wrapper {
      position: relative;
      .img-circle {
        width: 20px;
        height: 20px;
        background-color: #ddd;
        border-radius: 20px;
        position: absolute;
        right: 5px;
        bottom: 5px;
        .fas {
          display: none;
          line-height: 21px;
          font-size: 12px;
          color: #ffffff !important;
        }
      }
    }
  }

  &.active {
    .box-image-choice-option-quiz {
      border-color: $primary-color;
      .img-circle .fas {
        display: block;
        color: $primary-color;
      }
      .img-circle {
        background-color: $primary-color;
      }
    }
  }
}

.pick-image-options {
  margin-bottom: 8px;

  &.has-many-option {
    margin-top: 16px;
  }

  &.has-2-option {
    .masonry {
      column-count: 1;
      .brick {
        &:first-child {
          .box-image-choice-option-quiz {
            margin-right: 8px;
          }
        }
        &:last-child {
          .box-image-choice-option-quiz {
            margin-left: 8px;
          }
        }
      }
    }
  }
}

/* Masonry image effects */
.masonry .brick img {
  transition: all 0.5s ease-in-out;
  backface-visibility: hidden; /* Remove Image flickering on hover */
  max-width: 100%;
  display: block;
  margin: 0 auto;
}

/* Bordered masonry */
.masonry.bordered {
  column-rule: 1px solid #eee;
  column-gap: 50px;
}

.masonry.bordered .brick {
  padding-bottom: 25px;
  margin-bottom: 25px;
  border-bottom: 1px solid #eee;
}

/* Gutterless masonry */
.masonry.gutterless {
  column-gap: 0;
}

.masonry.gutterless .brick {
  margin-bottom: 0;
}

.progress-bar-time-limit {
  padding: 0 16px;
  margin-bottom: -16px;
}
</style>
